import { doc, setDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const DeleteExpense = async (ExpenseId) => {
  try {
    const ExpenseRef = doc(db, "Expenses", ExpenseId);

    await setDoc(
      ExpenseRef,
      {
        IsDeleted: true,
      },
      { merge: true }
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteExpense;
